import {useTranslation} from '@aboutyou/i18n';
import {Button} from '@aboutyou/ui-components';
import React from 'react';
import {Control, useWatch} from 'react-hook-form';
import styled from 'styled-components';
import {WEAK_LENGTH} from '../utils/password';

interface ChangePasswordButtonProps {
  control: Control<{
    currentPassword: string;
    password: string;
    confirmPassword: string;
  }>;
  isSubmitting: boolean;
  disabled?: boolean;
  buttonLabel?: string;
}

const defaultEmptyPassword = {
  password: '',
  confirmPassword: '',
  currentPassword: '',
};

export const ChangePasswordButton = ({
  control,
  isSubmitting,
  disabled = false,
  buttonLabel,
}: ChangePasswordButtonProps) => {
  const {t} = useTranslation();
  const fields = useWatch<typeof defaultEmptyPassword>({
    control,
    defaultValue: defaultEmptyPassword,
  });

  const {password, confirmPassword} = {...defaultEmptyPassword, ...fields};

  const differentPasswords = password !== confirmPassword;

  return (
    <SubmitButton
      data-testid="changePasswordButton"
      isLoading={isSubmitting}
      htmlType="submit"
      disabled={password.length < WEAK_LENGTH || differentPasswords || disabled}
    >
      {buttonLabel ?? t('Save password')}
    </SubmitButton>
  );
};

const SubmitButton = styled(Button)`
  margin: 1.5rem auto;
`;
